import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService, AlertType } from '../../services/alert.service';
import { VerifyPermissionService } from '../../services/API/user/verify-permission.service';
import { VerifyPermissionRequest } from '../../services/requests/user/verify-permission.request';
import { UserRoleEnum } from '../../enum/user-role.enum';

@Component({
    selector: 'app-check-restricted-overdue-medication-modal',
    templateUrl: './check-restricted-overdue-medication-modal.component.html',
    styleUrls: ['./check-restricted-overdue-medication-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CheckRestrictedOverdueMedicationModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private alertService: AlertService,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<CheckRestrictedOverdueMedicationModalComponent>,
    public verifyPermissionService: VerifyPermissionService,
    private formBuilder: FormBuilder,) { }

  public model: FormGroup;
  public hide: boolean = false;
  public isLoading: boolean = false;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      login: ['', [Validators.required]],
      password: ['', [Validators.required]],
      justification: ['', [Validators.required]],
    });
  }

  submit() {
    if (this.model.invalid || this.isLoading) {
      this.alertService.show('Erro', "É necessário preencher todos os campos obrigatórios.", AlertType.error);
      return;
    }

    this.isLoading = true;
    let verifyPermissionRequest = new VerifyPermissionRequest();
    verifyPermissionRequest.login = this.model.get('login').value;
    verifyPermissionRequest.password = this.model.get('password').value;
    verifyPermissionRequest.permissionEnum = UserRoleEnum.liberador_checar_atrasado_com_restrição;

    this.verifyPermissionService.verifyPermission(verifyPermissionRequest).subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        if (response && response.havePermission) {
          response.justification = this.model.get('justification').value;

          this.matDialogRef.close({ confirm: true, response: response });
        }
        else
          this.alertService.show('Erro', "O usuário não possui permissão para liberar a checagem com restrição.", AlertType.error);
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isLoading = false;
      }
    });
  }

  close(){
    this.matDialogRef.close({confirm: false});
  }
}